import { render } from "./OrderItem.vue?vue&type=template&id=507f72d0&scoped=true&ts=true"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"

import "./OrderItem.vue?vue&type=style&index=0&id=507f72d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507f72d0"]])

export default __exports__